import { MapKeysDTO } from '@DTOs';

export function sortByEntityHierarchy(a: MapKeysDTO, b: MapKeysDTO) {
    return a.entityHierarchy.localeCompare(b.entityHierarchy);
}
